/**
 * Perdele de Poveste: componentele unui set (perdeaua și draperia, legate prin proprietatea `_Set`) se scot din coș
 * împreună (pe Ella `custom-set-bundle-cart`, 2026-08-14). Butonul de ștergere al unei componente poartă
 * `data-perdele-set` (din `snippets/cart-products.liquid`); clicul e prins înaintea delegării Horizon și ambele
 * linii pleacă printr-o singură actualizare `Shopify.actions.updateCart`, care împrospătează sertarul și pagina.
 * Liniile obișnuite rămân pe fluxul Horizon.
 */

/** @param {string} setId */
async function stergeSetul(setId) {
  const raspuns = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
  if (!raspuns.ok) throw new Error(`cart.js ${raspuns.status}`);
  const cos = await raspuns.json();
  const lines = cos.items
    .filter((/** @type {any} */ it) => it.properties?._Set === setId)
    .map((/** @type {any} */ it) => ({ id: it.key, quantity: 0 }));
  if (!lines.length) return;
  const actions = /** @type {any} */ (window.Shopify)?.actions;
  if (!actions?.updateCart) throw new Error('Shopify.actions.updateCart lipsește');
  await actions.updateCart({ lines }, { event: { context: 'cart' } });
}

/** @param {MouseEvent} event */
function laClic(event) {
  const tinta = event.target instanceof Element ? event.target : null;
  const buton = tinta?.closest('button[data-perdele-set]');
  if (!(buton instanceof HTMLButtonElement)) return;
  const setId = buton.dataset.perdeleSet || '';
  if (!setId) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  if (!window.confirm(buton.dataset.perdeleSetIntrebare || '')) return;

  buton.disabled = true;
  stergeSetul(setId)
    .catch((error) => {
      console.error('[perdele-calc-cos] setul nu s-a putut scoate', error);
      window.location.reload();
    })
    .finally(() => {
      buton.disabled = false;
    });
}

if (!window.perdeleSetCos) {
  window.perdeleSetCos = true;
  window.addEventListener('click', laClic, { capture: true });
}
